import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import axios from "axios";
import { NavLink } from "react-bootstrap";
import ConfirmDeleteModal from './ConfirmationModelDelete';
import { saveAs } from 'file-saver';
import { Parser } from 'json2csv';

const ClassifiedList = () => {
  const [categories, setCategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState({ address: "", pincode: "" });
  const [showModal, setShowModal] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const history = useHistory();
  const token = localStorage.getItem('authToken');

  const getData = async () => {
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/classified`, {
        params: {
          page: currentPage,
          address: searchQuery.address,
          pincode: searchQuery.pincode
        }
      },{
        headers: {
          Authorization: `Bearer ${token}`, 
        }
      });
      setCategories(response.data.classifieds);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.log(error);
    }
  };

  const handleEdit = (id) => {
    history.push(`/editclassified/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`https://samaj.aasmo.in/api/admin/classified/${id}`,{
        headers: {
          Authorization: `Bearer ${token}`, 
        }
      });
      if (response) {
        console.log("Deleted Successfully");
        getData();
      }
    } catch (error) {
      console.log(error);
    }
    setShowModal(false);
  };

  const handleDeleteClick = (id) => {
    setSelectedCategoryId(id);
    setShowModal(true);
  };

  useEffect(() => {
    getData();
  }, [currentPage, searchQuery]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearchChange = (e) => {
    setSearchQuery({
      ...searchQuery,
      [e.target.name]: e.target.value
    });
  };

  const handleDownload = () => {
    const fields = [
      "id", "title", "category.name", "image","price","pincode","address", "description", "createdAt"
  ];
  const json2csvParser = new Parser({ fields });
  const csv = json2csvParser.parse(categories);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, 'classified_list.csv');
}


const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
};
const formatDescription = (description) => {
  return description.length > 10 ? description.slice(0, 10) + '...' : description;
};

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="header">
          <h2>Classified List</h2>
        </div>
        <div className="d-flex justify-content-start">
          <div className="input-group m-b-10 col-lg-6">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <i className="icon-magnifier"></i>
              </span>
            </div>
            <input
              type="text"
              className="form-control"
              placeholder="Search By Address"
              name="address"
              value={searchQuery.address}
              onChange={handleSearchChange}
            />
            <input
              type="text"
              className="form-control"
              placeholder="Search By Pincode"
              name="pincode"
              value={searchQuery.pincode}
              onChange={handleSearchChange}
            />
          </div>
          <div>
          <button className="btn btn-primary" onClick={handleDownload}>Download CSV</button>
          </div>
        </div>
        <div className="body table-responsive">
          <table className="table table-hover">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Title</th>
                <th>Category Name</th>
               
                <th>Price</th>
                <th>Pincode</th>
                <th>Address</th>
              
                <th>Description</th>
                <th>Status</th>
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody >
              {categories.map((category, index) => {
                   let statusClass;
                   switch (category.status) {
                     case 'no':
                       statusClass = 'text-danger';
                       break;
                     case 'yes':
                     case 'approved':
                       statusClass = 'text-success';
                       break;
                     default:
                       statusClass = 'text-primary';
                   }
                 
                return (
                  <tr key={category.id}>
                    <td>{(currentPage - 1) * 10 + index + 1}</td>
                    <td>{formatDescription(category.title)}</td>
                    <td>{formatDescription(category?.category?.name)}</td>
                   
                    <td>{category.price}</td>
                    <td>{category.pincode}</td>
                    <td>{formatDescription(category.address)}</td>
                 
                    <td>{formatDescription(category.description)}</td>
                    <td className={statusClass}>
                      {category.status === 'no' ? 'Rejected' : category.status === 'yes' || category.status === 'approved' ? 'Approved' : 'Pending'}
                    </td>
                    <td> {formatDate(category.createdAt)}</td>
                    <td>
                      <i className="icon-pencil" onClick={() => handleEdit(category.id)}></i>
                      &nbsp;&nbsp;
                      <i className="fa fa-trash-o" onClick={() => handleDeleteClick(category.id)}></i>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="body">
          <nav aria-label="Page navigation example" style={{ display: 'flex', justifyContent: 'center' }}>
            <ul className="pagination">
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <NavLink
                  to="#"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Previous
                </NavLink>
              </li>
              {[...Array(totalPages).keys()].map(page => (
                <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                  <NavLink
                    to="#"
                    className="page-link"
                    onClick={() => handlePageChange(page + 1)}
                  >
                    {page + 1}
                  </NavLink>
                </li>
              ))}
              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                <NavLink
                  to="#"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <ConfirmDeleteModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        handleConfirm={() => handleDelete(selectedCategoryId)}
      />
    </div>
  );
};

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, {})(ClassifiedList);
